import { Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Motion } from '~/components/AssetStore';
import Avatar from '~/components/AssetStore/Avatar/Avatar';
import ModalView from '~/components/atomic/Modal/Modal.view';
import { FullScreenLoading, HelmetHead } from '~/components/common';

export default function AssetStore() {
  const navigate = useNavigate();

  return (
    <>
      <HelmetHead title='Store' />

      <Suspense fallback={<FullScreenLoading />}>
        <ModalView
          type={'single'}
          title={'Coming soon'}
          content={
            <>
              This feature is coming soon. <br /> Thank you for your patience
            </>
          }
          buttonName={'Okay'}
          handleActionButton={() => navigate(-1)}
        />

        <Container>
          <Avatar />
          <Motion />
        </Container>
        {/* <AssetModal setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} /> */}
      </Suspense>
    </>
  );
}

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 0 0 ${theme.layout.chat_navigation_height};
    gap: 12px;
  `}
`;
